<script>
import { redirectToAgentLogin } from "../../helpers/routerHelper";
import RequestAgentKitDialog from "../common/requestAgentKitDialog.vue";

export default {
  name: "agentSignInSection",
  data() {
    return {
      requestAgentDialogVisible: false
    };
  },
  components: { RequestAgentKitDialog },
  methods: {
    redirectToAgentLogin,
    requestAgentKit() {
      this.requestAgentDialogVisible = true;
    },
  }
};
</script>

<template>
  <el-row style="padding: 20px;background-color: #fff">
    <el-col :span="24" style="display: flex; flex-direction: column">
      <el-row>
        <el-col :span="24" class="agent-question-wrapper">
          <span class="agent-question-style">Are you an agent ? </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col
          :span="24"
          style="display: flex; justify-content: flex-start; padding: 10px 10px"
        >
          <el-button
            class="agent-sign-in-btn"
            type="primary"
            @click="requestAgentKit"
            >Request Agent Kit</el-button
          >
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col
          :span="24"
          style="display: flex; justify-content: flex-start; padding: 10px 10px "
        >
          <el-button
            class="agent-sign-in-btn"
            type="primary"
            @click="redirectToAgentLogin"
          >Agent Sign in</el-button
          >
        </el-col>
      </el-row>
    </el-col>
    <request-agent-kit-dialog v-if="requestAgentDialogVisible" :request-agent-dialog-visible="requestAgentDialogVisible" @onClose="requestAgentDialogVisible = false" />
  </el-row>
</template>

<style scoped>
.agent-question-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.agent-question-style {
  color: #003333;
  font: 500 25px DINosaur-a, sans-serif;
  display: flex;
  justify-content: flex-start;
}

.account-creation-instruction {
  padding-left: 10px;
  color: #003333;
  font-weight: 400;
}

.agent-sign-in-btn {
  color: #fff;
  text-align: center;
  border: 3px solid #003333;
  background-color: #003333;
  width: 100%;
  font: 500 15px DINosaur-a, sans-serif;
  border-radius: 5px;
}

@media (max-width: 817px) {
  .agent-question-style {
    font-size: 20px;
  }
}
@media (max-width: 520px) {
  .agent-question-style {
    font-size: 20px;
  }
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .agent-question-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .agent-question-style {
    font-size: 20px;
  }
  .agent-sign-in-btn {
    font-size: 14px;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
}
</style>



// WEBPACK FOOTER //
// src/components/package/agentSignInSection.vue